import React from 'react';
import { Icon } from 'semantic-ui-react';
import { shape } from 'prop-types';

const SocialLinks = ({ ministry }) => {
  const { facebook, twitter, youtube } = ministry;
  return (
    <div>
      {facebook ? (
        <a href={facebook}>
          <Icon link size="large" color="orange" name="facebook" />
        </a>
      ) : null}
      {twitter ? (
        <a href={twitter}>
          <Icon link size="large" color="orange" name="twitter" />
        </a>
      ) : null}
      {youtube ? (
        <a href={youtube}>
          <Icon link size="large" color="orange" name="youtube" />
        </a>
      ) : null}
    </div>
  );
};

SocialLinks.propTypes = {
  ministry: shape().isRequired,
};

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/components/SocialLinks.jsx